import { render, staticRenderFns } from "./SendNotificationModal.vue?vue&type=template&id=44e7f53a&"
import script from "./SendNotificationModal.vue?vue&type=script&lang=js&"
export * from "./SendNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./SendNotificationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports